import { getSubmissionStatusTag } from '../constants/submission-status-tags'
import type { MissionSubmission } from '../types/mission'

import { Badge } from '@/shared/ui/badge'

interface SubmissionStatusTagProps {
  status?: MissionSubmission['status'] | null
}

export function SubmissionStatusTag({ status }: SubmissionStatusTagProps) {
  const tag = getSubmissionStatusTag(status)
  if (!tag) return null

  return <Badge variant={tag.variant}>{tag.name}</Badge>
}
